import React, { Component, Fragment } from 'react';
import { BreadCrumb, Card, Modal,Confirm } from '../../components';
import { Translate } from '../../contexts/Language';
import DataTable from 'react-data-table-component';
import { DataTableColumns } from '../../config/DataTableColumns';
import { Service } from '../../services';
import { Config } from '../../config';
import { ErrorMessage, Validator, VRules, VConditions } from '../../components/Validator';
import Select from 'react-select';

export class Users extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dataTable: {
                columns: DataTableColumns.userList,
                rows: []
            },
            formData: {
                id: 0,
                firstName: "",
                lastName: "",
                status: false,
                role: null,
                email: "",
                qrStatus:false,
            },
            validation: {
                error: false,
                message: ""
            },
            modal: false,
            modalTitle: "",
            isNew: false
        }
        this.onEdit = this.onEdit.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.roles = [
            { value: 0, label: "Admin" },
            { value: 1, label: "Personnel" },
            { value: 2, label: "Currency Manager" },
            { value: 3, label: "Report Manager" },
        ];

        this.countryOptions = [];
    }

    componentDidMount() {
        this.onDataTable(true);
    }

    onDataTable() {

        Config.utilities.loadingFetch();

        Service.User.UserList().then(response => {
            if (response) {

                let dataTable = this.state.dataTable;

                dataTable.rows = response;

                this.setState({
                    dataTable: dataTable
                });

            }
            Config.utilities.loadingFetch();
            this.onCountryList();
        });
    }
    onCountryList() {


        Config.utilities.loadingFetch();

        Service.TransferOptions.CountryList().then(response => {

            if (response) {

                this.countryOptions = response.map(item => ({ value: item.name, label: <span className="capitalize"><img src={"https://www.countryflags.io/" + item.code + "/shiny/24.png"} alt="Flag" width="24" className="mb-1 mr-1" onError={(e) => e.target.src = '/assets/images/flags/null.png'} /> {item.name}</span> }));
            }

            Config.utilities.loadingFetch();

        });
    }
    onFormChange(value, key) {

        let formData = this.state.formData;

        formData[key] = value;

        this.setState({
            formData
        });
    }

    onNew(modal) {
        this.setState({
            formData: {
                id: 0,              
                role: null,
                status: false,
                country: []
            },
            modal: modal === false ? false : true,
            modalTitle: Translate("Add New User"),
            validation: {
                error: false,
                message: ""
            },
            isNew: true,
        });
    }

    onEdit(id) {

        Config.utilities.loadingFetch();

        let formData = this.state.formData;
        formData.role = this.roles.filter(filter => filter.value === 1)[0];
        formData.status = false;

        this.setState(
            {
                modal: true,
                validation: {
                    error: false,
                    message: "",
                    formData: formData
                },
                isNew: false,
                modalTitle: Translate("Edit User")
            });

        Service.User.Detail({ 'id': id }).then(response => {

            if (response) {

                response.role = this.roles.filter(filter => filter.value === response.role)[0];

                if (response.country.length > 0) {
                    response.country = this.countryOptions.filter(item => response.country.includes(item.value));
                }

                this.setState({
                    formData: response
                })
            }
            Config.utilities.loadingFetch();
        });

    }

    onSave() {

        Confirm({
            title: Translate("Are you sure?"),
            type: { warning: true },
            description: Translate("This withdrawal will be confirmed"),
            onConfirm: () => {
                let form = this.state.formData;

                let data = {
                    Id: form.id,
                    FirstName: form.firstName,
                    LastName: form.lastName,
                    Status: form.status,
                    Role: form.role.value,
                    email: form.email,
                    country: (form.country ? form.country.map(item => item.value) : []) ,
                    QrStatus:form.qrStatus
                }
        
                if (this.isValid(form)) {
                    Config.utilities.loadingFetch();
        
                    Service.User.Save(data).then(response => {
        
                        if (response.error) {
                            this.setState({
                                validation: {
                                    error: response.error,
                                    message: response.message
                                }                        
                            });
                        }
                        else {
                            this.onNew(false);
                            this.onDataTable();
                        }
        
                        Config.utilities.loadingFetch();
                    });
                }
            },
            onCancel: () => {

            }
        });
     
    }
    isValid(data) {


        VRules["firstName"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("First name can not be empty.")
        }

        VRules["lastName"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Last name can not be empty.")
        }
        if (this.state.isNew) {
            VRules["email"] = {
                Invalid: (value) => {
                    return VConditions.Required(value)
                },
                Message: Translate("Email can not be empty.")
            }
        }



        let error = Validator.Valid(data, this.Refs);

        this.setState({
            validation: error
        });

        return !error.error;
    }

    onDelete(id){

        Confirm({
            title: Translate("Are you sure?"),
            type: { warning: true },
            description: Translate("This withdrawal will be confirmed"),
            onConfirm: () => {
                Config.utilities.loadingFetch();
                Service.User.Delete({'id':id}).then(response => {

                    if (response.error) {
                        this.setState({
                            validation: {
                                error: response.error,
                                message: response.message
                            }                        
                        });
                    }
                    else {
                        this.onNew(false);
                        this.onDataTable();
                    }
        
                    Config.utilities.loadingFetch();
                });
            },
            onCancel: () => {

            }
        });
   
    }

    render() {
        return (
            <Fragment>
                <BreadCrumb Title={Translate("Users")} Name={Translate("Users")} />
                <Card Title="Users" Description="Personnel Panel Users">
                    <Modal Title={Translate("Edit Black List")} Show={this.state.modal} onClose={(e) => this.setState({ modal: false })}>
                        <div className="row mt-1 mb-1">
                            <p className="text-muted mb-2 ml-1 col-md-12 font-12">{Translate("Role Information")}</p>
                            <div className="col-md-12">
                                <form className="form-horizontal" name="saveForm" ref={this.Refs}>
                                    <ErrorMessage Validation={this.state.validation} />
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="login" className="col-sm-4 col-form-label">{Translate("First Name")}</label>
                                        <div className="col-sm-8">
                                            <input className="form-control" type="text" id="firstName" name="firstName" value={this.state.formData.firstName} autoComplete="off" onChange={(e) => this.onFormChange(e.target.value, "firstName")} />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="transferOption" className="col-sm-4 col-form-label">{Translate("Last Name")}</label>
                                        <div className="col-sm-8">
                                            <input className="form-control" type="text" id="lastName" name="lastName" value={this.state.formData.lastName} autoComplete="off" onChange={(e) => this.onFormChange(e.target.value, "lastName")} />
                                        </div>
                                    </div>
                                    {this.state.isNew ?
                                        <div className="form-group row ml-1 mr-1">
                                            <label htmlFor="transferOption" className="col-sm-4 col-form-label">{Translate("Email")}</label>
                                            <div className="col-sm-8">
                                                <input className="form-control" type="text" id="email" name="email" value={this.state.formData.email} autoComplete="off" onChange={(e) => this.onFormChange(e.target.value, "email")} />
                                            </div>
                                        </div> : ""}
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="transferType" className="col-sm-4 col-form-label">{Translate("Status")}</label>
                                        <div className="col-sm-8">
                                            <input type="checkbox" id="status" name="status" switch="dark" checked={this.state.formData.status} onChange={(e) => this.onFormChange(!this.state.formData.status, "status")} />
                                            <label htmlFor="status" data-on-label="Yes" data-off-label="No" className="mt-2 mb-1"></label>
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="transferType" className="col-sm-4 col-form-label">{Translate("User Role")}</label>
                                        <div className="col-sm-8">
                                        <Select
                                            id="transferType"
                                            value={this.state.formData.role}
                                            onChange={(option) => this.onFormChange(option, "role")}
                                            options={this.roles}
                                            isMulti={false}
                                            name="transferType"
                                        />
                                            {/* <input type="checkbox" id="isAdmin" name="isAdmin" switch="dark" checked={this.state.formData.isAdmin} onChange={(e) => this.onFormChange(!this.state.formData.isAdmin, "isAdmin")} />
                                            <label htmlFor="isAdmin" data-on-label="Yes" data-off-label="No" className="mt-2 mb-1"></label> */}
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="transferOption" className="col-sm-4 col-form-label">{Translate("Reportable Countries")}</label>
                                        <div className="col-md-8">
                                            <Select
                                                id="reportableCountries"
                                                value={this.state.formData.country}
                                                onChange={(option) => this.onFormChange(option, "country")}
                                                options={this.countryOptions}
                                                isMulti={true}
                                                name="transferOption"
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="transferType" className="col-sm-4 col-form-label">{Translate("Qr Status")}</label>
                                        <div className="col-sm-8">
                                            <input type="checkbox" id="qrStatus" name="qrStatus" switch="dark" checked={this.state.formData.qrStatus} onChange={(e) => this.onFormChange(!this.state.formData.qrStatus, "qrStatus")} />
                                            <label htmlFor="qrStatus" data-on-label="On" data-off-label="Off" className="mt-2 mb-1"></label>
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="save-form" className="col-sm-4 col-form-label"></label>
                                        <div className="col-sm-8">
                                            <button type="button" className="btn btn-info float-right" onClick={(e) => this.onSave()}><i className="far fa-save mr-1"></i> {Translate("Save Form")}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal>
                    <div className="row">
                        <div className="col-md-12">
                            <button type="button" className="btn btn-info position-absolute add-new-button tabless" onClick={(e) => this.onNew()}><i className="fas fa-plus"></i> {Translate("Add New Login")}</button>
                            {this.state.dataTable.rows.length === 0 ? (
                                <div className="alert alert-light" role="alert">
                                    <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                </div>) :
                                (<DataTable
                                    noHeader={true}
                                    columns={this.state.dataTable.columns(this.onEdit, this.onDelete)}
                                    data={this.state.dataTable.rows}
                                    defaultSortField="id"
                                    defaultSortAsc={false}
                                    pagination
                                    highlightOnHover />)}
                        </div>
                    </div>
                </Card>
            </Fragment>)
    }
}